import SectionComponent from './SectionComponent'
export default SectionComponent
